import { userFields } from './users';

const couponsFields = {
  CODE: 'Code',
  ENABLED: 'Enabled',
  NAME: 'Code',
  TYPE: 'Type',
  XVALUE: 'XValue',
  YVALUE: 'YValue',
};
const couponsTable = 'Coupons';
const couponsTypes = {
  FREE_RETURN_SHIPPING: 'Free return shipping',
  X_CARDS_FREE: 'X cards free',
  X_CARDS_FREE_WITH_FREE_SHIPPING: 'X cards free with free return shipping',
  X_CARDS_PAID_GETS_Y_CARDS_FREE: 'X cards paid gets Y cards free',
  X_PERCENT_OFF_PER_CARD: 'X% off per card',
  X_PRICE_PER_CARD: 'X price per card',
};

const ratesTable = 'Rates';
const ratesFields = {
  NAME: 'Name',
  VALUE: 'Rate',
};
const ratesTypes = {
  SUBMISSION_PER_ITEM_HARD_CASE: 'submission-per-item-hard-case',
  SUBMISSION_PER_ITEM_PREP: 'submission-per-item-prep',
  SUBMISSION_PER_ITEM_REVIEW: 'submission-per-item-review',
  SUBMISSION_INSURANCE_PER_STEP: 'submission-insurance-per-step',
  SUBMISSION_INSURANCE_STEP: 'submission-insurance-step',
};

const shippingFields = {
  ENABLED: 'Enabled',
  NAME: 'Unique ID',
  RATE: 'Rate',
  TYPE: 'Type',
  XVALUE: 'XValue',
  YVALUE: 'YValue',
};
const shippingTable = 'Shipping';
const shippingTypes = {
  FLAT: 'Flat',
  ADDITIONAL_FROM_X_TO_Y_TOTAL_HARD_CASES: 'Additional from X to Y total hard cases',
};

const smsFields = {
  NAME: 'Name',
  VALUE: 'Value',
};

const stripeTable = 'Stripe';
const stripeFields = {
  NAME: 'Name',
  VALUE: 'Value',
};

const textsTable = 'Texts';
const textsFields = {
  NAME: 'Name',
  VALUE: 'Value',
};

const uiTable = 'UI';
const uiFields = {
  SHOW_METRONIC_STUFF: 'Show Metronic stuff',
  USER_ID: userFields.USER_ID,
};

export {
  couponsFields,
  couponsTable,
  couponsTypes,
  ratesFields,
  ratesTable,
  ratesTypes,
  shippingFields,
  shippingTable,
  shippingTypes,
  smsFields,
  stripeFields,
  stripeTable,
  textsFields,
  textsTable,
  uiFields,
  uiTable,
};
